import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { UserManagementService } from '../../services/user-management.service';

@Component({
  selector: 'app-redirect',
  templateUrl: './redirect.component.html',
  styleUrl: './redirect.component.scss',
})
export class RedirectComponent {
  constructor(
    private router: Router,
    private userManagementService: UserManagementService,
  ) {
    const isNflAdmin = this.userManagementService.isNflAdmin();
    const path = isNflAdmin ? '/history' : '/upload';

    this.router.navigate([`files/${path}`]);
  }
}
